export enum ViewerType {
  CONVERSATION = 'CONVERSATION',
  PRODUCT_REQUEST = 'PRODUCT_REQUEST',
}
